import { render, staticRenderFns } from "./OptionsContent.vue?vue&type=template&id=50c8f79a&scoped=true"
import script from "./OptionsContent.vue?vue&type=script&lang=js"
export * from "./OptionsContent.vue?vue&type=script&lang=js"
import style0 from "./OptionsContent.vue?vue&type=style&index=0&id=50c8f79a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8f79a",
  null
  
)

export default component.exports